<template>
  <v-stepper v-model="e1" style="padding: 1em">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">
        <span class="text-sm-h6 text-md-h6">Choix du modèle</span>
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">
        <span class="text-sm-h6 text-md-h6"> Saisie d'informations </span>
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
        <span class="text-sm-h6 text-md-h6"> Génération du CV </span>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="mb-12" color="1" style="padding: 2em">
          <h5
            class="text-center text-lg-h4 text-sm-h5"
            style="margin-bottom: 1.5em"
          >
            Choisissez un modèle pour continuer
          </h5>
          <v-row>
            <v-col
              v-for="img in cvTemplatesList"
              :key="img.id"
              class="align-content-end"
              align="center"
            >
              <a v-on:click="chooseCv(img)">
                <v-img
                  :src="`${apiHost}/cv/${img.imageIllustration}`"
                  max-width="300"
                  height="400"
                  class="grey lighten-2"
                ></v-img>
              </a>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-row>
          <v-col cols="12" md="6" style="margin-bottom: 3em">
            <v-card class="mb-12" height="100vh" style="overflow-y: scroll">
              <template>
                <v-stepper v-model="e6" vertical>
                  <v-stepper-step :complete="e6 > 1" step="1">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-account-circle
                      </v-icon>
                      Choisissez une photo</span
                    >
                    <small>Facultatitf si le cv ne comporte pas de photo</small>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-card class="mb-12 pa-md-3" flat>
                      <v-row>
                        <v-col cols="12" md="5">
                          <div class="row">
                            <v-file-input
                              v-model="cvData.avatar"
                              truncate-length="30"
                              placeholder="Ajouter une photo pour votre Cv"
                              prepend-icon="mdi-upload-outline"
                              show-size
                              accept="image/*"
                            >
                              <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="uploadAvatar">
                      Continue
                    </v-btn>
                    <v-btn text @click="e1 = e1 - 1">
                      Revenir au choix du modèle
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 2" step="2">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-account-details-outline
                      </v-icon>
                      Informations personnelles</span
                    >
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <CvGeneratorPersonalInformationForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                    />
                    <v-btn text @click="e6 = 1">
                      Revenir au choix de l'avatar
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 3" step="3">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-briefcase-outline
                      </v-icon>
                      Expériences professionnelles
                    </span>
                  </v-stepper-step>
                  <v-stepper-content step="3">
                    <CvGeneratorWorkForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                    />
                    <v-btn text @click="e6 = 2">
                      Revenir aux informations personnelles
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 4" step="4">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-briefcase-outline
                      </v-icon>
                      Formations
                    </span>
                  </v-stepper-step>
                  <v-stepper-content step="4">
                    <CvFormationForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                    />

                    <v-btn text @click="e6 = 3">
                      Revenir aux experiences
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 5" step="5">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-briefcase-outline
                      </v-icon>
                      Compétences
                    </span>
                  </v-stepper-step>
                  <v-stepper-content step="5">
                    <CvCompetenceForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                    />
                    <v-btn text @click="e6 = 4">Revenir aux Formations</v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 6" step="6">
                    <span class="text-md-h6">
                      <v-icon style="padding-right: 0.3em; color: #6b6868">
                        mdi-briefcase-outline
                      </v-icon>
                      Centres d'intérêt et loisirs
                    </span>
                  </v-stepper-step>
                  <v-stepper-content step="6">
                    <CvCenterOfInterestForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                    />
                    <v-btn text @click="e6 = 5"> Revenir aux Compétences </v-btn>
                  </v-stepper-content>

                  <v-stepper-step step="7"> Langues </v-stepper-step>
                  <v-stepper-content step="7">
                    <CvLanguageForm
                      :informations-next-step-call-back="
                        informationsNextStepCallBack
                      "
                      :template-id="cvData.selectedTemplate"
                    />
                    <v-btn text @click="e6 = 6">
                      Revenir aux centres d'interets
                    </v-btn>
                  </v-stepper-content>
                </v-stepper>
              </template>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card>
              <v-card-title>Prévisualisation de votre Cv</v-card-title>
              <v-card-text>
                <iframe
                  style="padding: 2em"
                  id="cvPrevisualizer"
                  :src="this.cvData.cvPrevisualisationLink"
                  width="100%"
                  height="1000px"
                  v-if="visible"
                >
                </iframe>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>

        <v-btn color="primary" @click="e1 = 1"> Continue </v-btn>

        <v-btn text> Cancel </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import CvGeneratorPersonalInformationForm from "@/components/Candidate/CvGeneratorPersonalInformationForm";
import CvGeneratorWorkForm from "@/components/Candidate/CvGeneratorWorkForm";
import CvFormationForm from "@/components/Candidate/CvFormationForm";
import CvCompetenceForm from "@/components/Candidate/CvCompetenceForm";
import CvCenterOfInterestForm from "@/components/Candidate/CvCenterOfInterestForm";
import CvLanguageForm from "@/components/Candidate/CvLanguageForm";

export default {
  name: "GenerateCV",
  components: {
    CvGeneratorWorkForm,
    CvGeneratorPersonalInformationForm,
    CvFormationForm,
    CvCompetenceForm,
    CvCenterOfInterestForm,
    CvLanguageForm,
  },
  data() {
    return {
      apiHost: null,
      e1: 1,
      e6: 1,
      cvTemplatesList: null,
      visible: false,
      cvData: {
        cvPrevisualisationEndpoint:
          "/api/candidate/preview-resume/",
        cvPrevisualisationLink: null,
        cvPrevisualisationContent: null,
        selectedTemplate: null,
        avatar: null,
      },
    };
  },
  mounted() {
    this.apiHost = process.env.VUE_APP_JOB_BOARD_API_ENDPOINT;

    const httpService = new HttpClient();
    httpService
      .fetchFromApiPlatformUri(
        "/api/c_v_templates",
        localStorage.getItem("jwt-token")
      )
      .then((res) => {
        this.cvTemplatesList = res.data["hydra:member"];
        console.log(this.cvTemplatesList);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          this.$router.push("/logout");
        } else {
          alert("Une erreur s'est produite");
        }

        console.error(error);
      });
  },

  methods: {
    chooseCv(item) {
      this.cvData.selectedTemplate = item;

      this.e1 = 2;
      this.refreshCvView();
    },

    refreshCvView() {
      this.visible = false;
      this.cvData.cvPrevisualisationLink = `${this.apiHost}${this.cvData.cvPrevisualisationEndpoint}${this.cvData.selectedTemplate.id}?access_token=${localStorage.getItem("jwt-token")}`;
      this.visible = true;
      document.getElementById('cvPrevisualizer').src = this.cvData.cvPrevisualisationLink;
    },

    uploadAvatar() {
      if (this.cvData.avatar !== null) {
        const httpClient = new HttpClient();
        const formData = new FormData();
        formData.append("avatar", this.cvData.avatar);
        httpClient
          .uploadSeekerAvatarFile(formData, localStorage.getItem("jwt-token"))
          .then(() => {
            this.refreshCvView();
            this.e6 = 2;
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push("/logout");
            } else {
              alert("Une erreur s'est produite");
              console.log(error);
            }
          });
      } else {
        this.refreshCvView();
        this.e6 = 2;
      }
    },

    informationsNextStepCallBack(val) {
      this.e6 = val;
      this.refreshCvView();
    },
  },
};
</script>
